/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Profile_Hands_OffInputs */

const en_onboarding_v1_profile_hands_off = /** @type {(inputs: Onboarding_V1_Profile_Hands_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to invest without managing my portfolio every day.`)
};

const de_onboarding_v1_profile_hands_off = /** @type {(inputs: Onboarding_V1_Profile_Hands_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich möchte investieren, ohne mein Portfolio täglich zu verwalten.`)
};

const pt_br2_onboarding_v1_profile_hands_off = /** @type {(inputs: Onboarding_V1_Profile_Hands_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quero investir sem gerenciar meu portfólio todos os dias.`)
};

const tr_onboarding_v1_profile_hands_off = /** @type {(inputs: Onboarding_V1_Profile_Hands_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portföyümü her gün yönetmeden yatırım yapmak istiyorum.`)
};

const zh_cn2_onboarding_v1_profile_hands_off = /** @type {(inputs: Onboarding_V1_Profile_Hands_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我希望投资，但不想每天管理投资组合。`)
};

const zh_hk2_onboarding_v1_profile_hands_off = /** @type {(inputs: Onboarding_V1_Profile_Hands_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我希望投資，但不想每天管理投資組合。`)
};

const ko_kr2_onboarding_v1_profile_hands_off = /** @type {(inputs: Onboarding_V1_Profile_Hands_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매일 포트폴리오를 관리하지 않고 투자하고 싶습니다.`)
};

const ru_ru2_onboarding_v1_profile_hands_off = /** @type {(inputs: Onboarding_V1_Profile_Hands_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я хочу инвестировать, не управляя портфелем каждый день.`)
};

const es_419_onboarding_v1_profile_hands_off = /** @type {(inputs: Onboarding_V1_Profile_Hands_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quiero invertir sin administrar mi portafolio todos los días.`)
};

/**
* | output |
* | --- |
* | "I want to invest without managing my portfolio every day." |
*
* @param {Onboarding_V1_Profile_Hands_OffInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_profile_hands_off = /** @type {((inputs?: Onboarding_V1_Profile_Hands_OffInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Profile_Hands_OffInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_profile_hands_off(inputs)
	if (locale === "de") return de_onboarding_v1_profile_hands_off(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_profile_hands_off(inputs)
	if (locale === "tr") return tr_onboarding_v1_profile_hands_off(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_profile_hands_off(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_profile_hands_off(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_profile_hands_off(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_profile_hands_off(inputs)
	return es_419_onboarding_v1_profile_hands_off(inputs)
});